import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class OutpostSea1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.OUTPOST_SEA1;
}

export default OutpostSea1PoiTileEntity;
